import React, { useCallback, useMemo } from 'react';
import { LayoutSingleColumn, Page } from '../../components';
import { connect } from 'react-redux';
import { FormattedMessage } from '../../util/reactIntl';
import { sendContactMessage } from './ContactPage.duck';
import { ensureCurrentUser } from '../../util/data';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import ContactForm from '../../forms/ContactForm/ContactForm';

import css from './ContactPage.module.css';
import { useConfiguration } from '../../context/configurationContext';

const ContactPage = props => {
  const {
    currentUser,
    sendContactMessageInProgress,
    sendContactMessageError,
    sendContactMessageDone,
    onMessageSubmit,
    scrollingDisabled,
  } = props;

  const config = useConfiguration();

  const ensuredCurrentUser = useMemo(() => ensureCurrentUser(currentUser), [currentUser]);

  const { email, profile } = ensuredCurrentUser.attributes || {};
  const { firstName, lastName } = profile || {};

  const initialValues = useMemo(() => ({ firstName, lastName, email }), [
    firstName,
    lastName,
    email,
  ]);

  const handleSubmit = useCallback(
    values => {
      const { firstName, lastName, email, message } = values;
      onMessageSubmit({ firstName, lastName, email, message });
    },
    [onMessageSubmit]
  );

  return (
    <Page
      title={`Contact ${config.marketplaceName}`}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ContactPage',
        description: `Contact ${config.marketplaceName}`,
        name: `Contact ${config.marketplaceName}`,
      }}
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer currentPage="ContactPage" />}
        footer={<FooterContainer />}
        mainColumnClassName={css.staticPageWrapper}
      >
        <h1>
          <FormattedMessage id="ContactPage.title" />
        </h1>

        <ContactForm
          className={css.form}
          initialValues={initialValues}
          onSubmit={handleSubmit}
          inProgress={sendContactMessageInProgress}
          ready={sendContactMessageDone}
          error={sendContactMessageError}
        />
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const {
    sendContactMessageInProgress,
    sendContactMessageError,
    sendContactMessageDone,
  } = state.ContactPage;

  return {
    currentUser,
    sendContactMessageInProgress,
    sendContactMessageError,
    sendContactMessageDone,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onMessageSubmit: values => dispatch(sendContactMessage(values)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactPage);
